import { h, Fragment } from 'preact';
import FormStepLayout from '../../templates/FormStepLayout/FormStepLayout';
import useFormStore from '../../store/useFormStore';
import FranchiseInfoBlock from '../../components/blocks/FranchiseInfoBlock';
import UserInformationReviewBlock from '../../components/blocks/UserInformationReviewBlock';
import Alert from '../../components/Alert';
import { useOrderSubmission } from '../../util/useOrderSubmission';
import AppointmentDetailsList from '../../components/appointments/AppointmentDetailsList';
import WisetackBannerBlock from '../../components/blocks/WisetackBannerBlock';
import CartBlock from '../../components/cart/CartBlock';
import ShortLeadInfoBlock from '../../components/blocks/ShortLeadInfoBlock';


export default function Review({ onNext, onBack }) {
  // Use the order submission hook
  const { isSubmitting, submitError, handleSubmit, clearError } = useOrderSubmission(onNext);
  const isShortLeadForm = useFormStore(
    (state) => state.selectedEstimateType === 'on_site_estimate_short'
  );

  return (
    <FormStepLayout
      onBack={onBack}
      onNext={handleSubmit}
      leftSidebar={true}
      nextText={isSubmitting ? "Submitting..." : "Schedule My Appointment"}
      nextDisabled={isSubmitting}
      title="Review"
      headerAction={
        <button
          type="button"
          onClick={handleSubmit}
          disabled={isSubmitting}
          className="coit-button-sm hidden xl:block"
        >
          {isSubmitting ? "Submitting..." : "Schedule My Appointment"}
        </button>
      }
    >
      {submitError && (
        <Alert
          type="error"
          title="Submission Error"
          onClose={clearError}
          bordered
        >
          {submitError}
        </Alert>
      )}

      <div className="flex flex-col gap-4">
        {isShortLeadForm ? (
          <ShortLeadInfoBlock />
        ) : (
          <Fragment>
            <CartBlock />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <AppointmentDetailsList />
            </div>
          </Fragment>
        )}
        <WisetackBannerBlock />
        <div className="bg-white p-6 shadow-sm">
          <div className="text-2xl font-bold mb-6">
            Your Contact Information
          </div>
          <UserInformationReviewBlock />
        </div>
      </div>
    </FormStepLayout>
  );
}
